import { DataCell } from "./dataCell";

export class DataRow {
    cells: DataCell[] = []
}
